import React,{useState,useEffect} from 'react';
import { Swiper, SwiperSlide} from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import PlayListTile from './ui-elements/PlayListTile';
import { useStore } from '@nanostores/react';
import { zamzamSurahs } from '../../stores/sessionStore';
import { useInView } from 'react-intersection-observer';

const PlaylistSlide=()=>{
    const [contentSwiper, setContentSwiper] = useState(null);
    const [isPlaylistLoaded,setIsPlaylistLoaded]=useState(false);
    const [alimPlaylists,setAlimPlaylists]=useState(null);
    const [isVisible, setIsVisible] = useState(false);

    const { ref, inView } = useInView({
        triggerOnce: true, // Load only once when it comes into view
        threshold: 0.1, // Trigger when 10% of the component is in the viewport
    });

    const zamzamPlaylist=useStore(zamzamSurahs);

    useEffect(()=>{
        if(zamzamPlaylist!==null&&!isPlaylistLoaded)
        {
            setIsPlaylistLoaded(true);
        }

        if(isPlaylistLoaded)
        {
            const groupedPlaylist = [];

            zamzamPlaylist.items
            .filter(item => item.snippet.title.includes("Part")) // Only include items with "Part" in the title
            .forEach(item => {
                const title = item.snippet.title;

                // Extract the surah name without the initial "Surah XX:" part
                const surahMatch = title.match(/(?:Surah\s*\d*:\s*)?(.*?)(?:\s*-\s*Part|\s*Part)/i);
                const surahName = surahMatch ? surahMatch[1].trim() : title;

                // Find or create a surah entry
                let surahEntry = groupedPlaylist.find(entry => entry.surahName === surahName);
                
                if (!surahEntry) {
                    // If it doesn't exist, create a new surah entry
                    surahEntry = { 
                        surahName: surahName, 
                        parts: [] 
                    };
                    groupedPlaylist.push(surahEntry);
                }

                const cleanedTitle = title.replace(/^.*?(Part\s*\d+[^-]*)(?:\s*-\s*.*)?$/, '$1').trim();

                // Add the current part to the found or newly created surah entry
                surahEntry.parts.push({
                    title: cleanedTitle,
                    resourceId: item.snippet.resourceId,
                    thumbnail: item.snippet.thumbnails.high
                });
            });
                
            setAlimPlaylists(groupedPlaylist);
        }
    },[zamzamPlaylist,isPlaylistLoaded]);

    useEffect(() => {
        if (inView) {
            setIsVisible(true);
        }
    }, [inView]);

    return(
        <div ref={ref}>
            {
                isPlaylistLoaded&&alimPlaylists!==null&&isVisible?
                    <>
                        <div className='grid grid-cols-2 mt-16 mb-6 md:mt-32 md:mb-20'>
                            <div className='col-span-2 md:col-span-1'>
                                <h2 className="alim-text-color-style mb-2 "> Surah Playlists </h2>
                                <p className="alim-text-color-style mt-3 opacity-75">Explore curated surah playlists</p>
                            </div>
                            <div className='col-span-2 md:col-span-1 flex justify-end'>
                                <div className='flex justify-between w-32'>
                                    <button className="block w-14 h-14 alim-arrow-left-style bg-[length:52px_52px] bg-no-repeat hover:bg-arrow-left-hov-bg" onClick={()=>{contentSwiper.slidePrev()}}></button>
                                    <button className="block w-14 h-14 alim-arrow-right-style bg-[length:52px_52px] bg-no-repeat hover:bg-arrow-right-hov-bg" onClick={()=>{contentSwiper.slideNext()}}></button>
                                </div>
                            </div>
                        </div>

                        <Swiper
                            modules={[Autoplay]}
                            spaceBetween={10}
                            slidesPerView={1}
                            loop={true}
                            autoplay={{
                                delay: 5000,
                                disableOnInteraction: true,
                                pauseOnMouseEnter: true,
                            }}
                            onSwiper={setContentSwiper}
                        >
                            {
                                alimPlaylists.map((playlist,itemIndex)=>{
                                    return(
                                        <SwiperSlide key={itemIndex}>
                                            <PlayListTile alimPlaylist={playlist}/>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                    </>
                :
                    null
            }
        </div>
    );
}

export default PlaylistSlide;